import { FC, useEffect, useRef, useState } from 'react';
import { Grid, Text, Flex, Space, List, Image, UnstyledButton, Group, Drawer, Burger, Box, Popover, Divider } from '@mantine/core';
import { headerRoutes } from 'src/constants';
import { NavLink, Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Logo from 'src/assets/svg/logo.svg';
import classNames from 'classnames';
import { AccountMenu, LogoutButton } from './components';
import { getAccountOptions } from 'src/constants/accountOptions';
import { PATHS } from 'src/constants';
import styles from './styles.module.scss';
import { updateCurrent, useAppDispatch, useAppSelector } from 'src/store';
import { shallowEqual } from 'react-redux';
import { IUserData } from '@common/types/types';
import { apiInstance } from 'src/services';
import { useDisclosure, useMediaQuery } from '@mantine/hooks';
import { AutomatedAuditLoader, Button, SelectLanguage } from '@common/components';
import { numberLocalization } from 'src/helpers/numberLocalization';
// import { AlertTriangleFill, Lock } from '@geist-ui/icons';
// import AccountTypeAvatas from './components/AccountTypeAvatas/page';
import { AlertTriangleFill, ArrowUpRight , QuestionCircle, Share2, Lock,  ArrowRightCircle, FileText, ArrowDown, ArrowUp } from '@geist-ui/icons';
import { ReactComponent as ProfileIcon } from 'src/assets/svg/profile.svg';

const Header: FC = () => {
  const isLargeDevice = useMediaQuery('(max-width: 1199px)', true);
  const dispatch = useAppDispatch();
  const [t] = useTranslation('nav');
  const options = getAccountOptions();
  const { data } = useAppSelector((state) => state.user, shallowEqual);
  const [headerLinks, setHeaderLinks] = useState(headerRoutes);
  const { isSuperAdmin } = useAppSelector((state) => state.user.data);
  const [drawerOpened, { toggle: toggleDrawer, close: closeDrawer }] = useDisclosure(false);
   
  useEffect(() => {
    let newHeaderLinks;
    if (isSuperAdmin) {
      newHeaderLinks = headerLinks.map((e) => Object.assign({}, e, { visible: e.isSuperAdmin === isSuperAdmin }));
    } else {
      newHeaderLinks = headerLinks.map((e) =>
        e.field ? Object.assign({}, e, { visible: data[e.field as keyof IUserData] }) : e,
      );
    }
    setHeaderLinks(newHeaderLinks);
  }, [data]);
  const { metadata, paymentPlan, subscriptionScannedPages } = useAppSelector((state) => state.payment.data);
  const { isLoading } = useAppSelector((state) => state.payment);

  const changeAvailableAccount = (field: string, value: boolean): void => {
    dispatch(updateCurrent({ data: { [field]: value } }));
  };

  const navigateToPayment = (): void => {
    apiInstance.get('payment/portal').then((res) => {
      window.open(res.data.url, '_blank');
    });
  };
  return (
    <header id='header_main' className={styles.header}>
      <Grid className={styles.innerWrapper} px={24} py={14} my={0}>
        <Group position="center" className={styles.burgerMenuContainer}>
            {isLargeDevice && (
              <Burger ml={'auto'} aria-label={`${t('toggleMenu')}`} opened={drawerOpened} onClick={toggleDrawer} />
            )}
        </Group>
        <Link id="main-logo" to={PATHS.AUTOMATED_AUDIT_SELECT} aria-label={`${t('logoLabel')}`}>
          <Image width={142} src={Logo} alt={t('logoAlt') ?? undefined} />
        </Link>
        <Flex className={styles.nav} align="center" justify={"flex-end"}>
          {!isSuperAdmin && (
            <>
              {!isLargeDevice && (
                <>
                <Flex align="left" gap={'7px'} >                  
                  <ul className={styles['subscription-dropdown']}>
                    <ArrowDown size={17} className={styles['ArrowDown']}/>
                      <li>
                        <Flex align="center" gap={'7px'} ml={'112px'} className={styles['subscriptionScannedPages']}>
                          {isLoading ? (
                            <AutomatedAuditLoader />
                          ) : (
                            <>
                              <UnstyledButton
                                aria-label={['free', 'free plan'].includes(paymentPlan) ? 'Your current plan is free, click here to change your current plan' : `Your current plan is ${paymentPlan}` }
                                className={styles.link}
                                onClick={() => {
                                  navigateToPayment();
                                }}>
                                {t(`subPlans.${paymentPlan}`)}
                              </UnstyledButton>
                              {/* <Text id="myPlan">{t('myPlan')}:</Text> */}
                              {subscriptionScannedPages > (+metadata.pageScansPerMonth * 90) / 100 && (
                                <AlertTriangleFill color="#A80000" stroke="#FFFFFF" aria-label={`${t('planAlert')}`} />
                              )}
                              <Text>
                                {numberLocalization(subscriptionScannedPages ?? 0)}/
                                {numberLocalization(Number(metadata.pageScansPerMonth))} {t('pagesScanned')}
                              </Text>
                            </>
                          )}
                          <Space w={15} />
                        </Flex>
                      </li>
                    </ul>
                {/* <AccountTypeAvatas  /> */}
                  {/* <Text id="myPlan">{t('myPlan')}:</Text> */}
                  {/* {isLoading ? (
                    <AutomatedAuditLoader />
                  ) : (
                    <>
                      <UnstyledButton
                        className={styles.link}
                        onClick={() => {
                          navigateToPayment();
                        }} >
                          {t(`subPlans.${paymentPlan}`)}

                      </UnstyledButton>
                      {subscriptionScannedPages > (+metadata.pageScansPerMonth * 90) / 100 && (
                        <AlertTriangleFill color="#A80000" stroke="#FFFFFF" aria-label={`${t('planAlert')}`} />
                      )}
                      <Text>
                        {numberLocalization(subscriptionScannedPages ?? 0)}/
                        {numberLocalization(Number(metadata.pageScansPerMonth))} {t('pagesScanned')}
                      </Text>
                    </>
                  )} */}
                  <Space w={15} />
                </Flex>
                </>
              )}
            </>
          )}
          {isSuperAdmin && !isLargeDevice ? (
            <div className={styles.logoutAdminView}>
              <LogoutButton />
            </div>
          ) : (
            <>
            {/* {
              !isLargeDevice && 
              // <SelectLanguage className={styles['language-header']} />
            }  */}
            <HelpMenu isLargeDevice={isLargeDevice} />
            {/* <UnstyledButton
                className={styles.shareBtn}
                >
                <Share2/> 
            </UnstyledButton>  */}
            <Space w={15} />
            
              {!isLargeDevice && <><AccountMenu options={options} data={data} onChange={changeAvailableAccount} /></> }
            </>

          )}
        </Flex>

        <>
          <Drawer
            size={'90%'}
            className={styles.innerWrapperMobile}
            opened={drawerOpened}
            onClose={closeDrawer}
            zIndex={1000}
            withCloseButton={false}>
            <Flex className={styles['mobile-wrapper']} px={24} py={14} my={0}>
              <div className={styles.menuHeader}>
                    <div className={styles.menuHeaderIcon}>
                        <ProfileIcon role={`${t('accountIconLabel')}`} />
                    </div>
                    <div className={styles.menuHeaderinfo}>
                          <span> {data.firstName}  {data.lastName} </span>
                          <span> {data.email} </span>
                    </div>
                </div>
              <Group ml={'auto'} position="center">
                <Burger aria-label={`${t('toggleMenu')}`} ml={'auto'} opened={drawerOpened} onClick={toggleDrawer} />
              </Group>
            </Flex>

            <Box p={'16px'} pr={'35px'} pl={'35px'}  id="language-container">
              <nav aria-label={`${t('menuNavLabel')}`}>
                <List className={styles.list}>
                  {headerLinks.map((route) => {
                    return (
                      route.visible && (
                        <List.Item key={route.path} w={'100%'} className={styles.liStyle}>
                          <NavLink onClick={toggleDrawer} to={route.path} className={classNames(styles.button)}>
                            {t(`${route.title}`)}
                          </NavLink>
                        </List.Item>
                      )
                    );
                  })}
                </List>
              </nav>
              {/* <SelectLanguage className={styles['language-header']} withBorder={false} displayLabel={false} /> */}
              <Flex className={styles.upgradeContainer} mt={'32px'} gap={'7px'}  align="left" wrap={'wrap'} direction={'column'}>
                <div >
                    <UnstyledButton
                      display={'inline'}
                      className={styles.link}
                      onClick={() => {
                        navigateToPayment();
                      }}>
                      {t(`subPlans.${paymentPlan}`)}
                    </UnstyledButton>
                    {/* <Text id="myPlan" display={'inline'}>{t('myPlan')}:</Text> */}
                    {subscriptionScannedPages > (+metadata.pageScansPerMonth * 90) / 100 && (
                      <AlertTriangleFill color="#A80000" stroke="#FFFFFF" aria-label={`${t('planAlert')}`} />
                    )}
                    <Text display={'inline'}>
                      {numberLocalization(subscriptionScannedPages ?? 0)}/
                      {numberLocalization(Number(metadata.pageScansPerMonth))} {t('pagesScanned')}
                    </Text>
                    <Space w={15} />
                </div>
                <div>
                    <Button className={styles.upgradeBtn} fullWidth onClick={()=>{ navigateToPayment(); }}>
                        {t('upgrade')}
                    </Button>
                </div>
              </Flex>
              <LogoutButton  className={styles.logoutBtn} />
            </Box>
          </Drawer>

          {/* <Group position="center">
            {isLargeDevice && (
              <Flex gap={"sm"} align={"center"}>
              <AccountTypeAvatas  />
              <Burger ml={'auto'} aria-label={`${t('toggleMenu')}`} opened={drawerOpened} onClick={toggleDrawer} />
              </Flex>
            )}
          </Group> */}
        </>
      </Grid>
    </header>
  );
};

export default Header;



interface HelpMenuProps {
  isLargeDevice: boolean;
}


interface HelpMenuProps {
  isLargeDevice: boolean;
}

const HelpMenu: FC<HelpMenuProps> = ({ isLargeDevice }) => {
  const { t } = useTranslation('nav');
  const [opened, setOpened] = useState(false);
  const [focusedIndex, setFocusedIndex] = useState<number | null>(null); // Track focused item
  const menuItemsRef = useRef<(any)[]>([]); // Store refs for each menu item

  const toggleOpened = () => setOpened((o) => !o);

  // Handle key down events for arrow navigation and allow Tab navigation
  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'ArrowDown') {
      e.preventDefault(); // Prevent default scroll
      setFocusedIndex((prevIndex) => (prevIndex === null ? 0 : Math.min(prevIndex + 1, menuItemsRef.current.length - 1)));
    } else if (e.key === 'ArrowUp') {
      e.preventDefault(); // Prevent default scroll
      setFocusedIndex((prevIndex) => (prevIndex === null ? 0 : Math.max(prevIndex - 1, 0)));
    }
    // Let Tab behavior work normally, so we don't override it
  };

  // Ensure the focused menu item gets focus
  useEffect(() => {
    if (focusedIndex !== null && menuItemsRef.current[focusedIndex]) {
      menuItemsRef.current[focusedIndex]?.focus();
    }
  }, [focusedIndex]);

  return (
    <Popover trapFocus width={360} opened={opened} onChange={setOpened}>
      <Popover.Target>
        <UnstyledButton
          onClick={toggleOpened}
          aria-label={'Support'}
          className={styles.helpNavMenu}
        >
          {!isLargeDevice ? (
            <Text className={styles.supportPart}>
              Support {opened ? <ArrowUp size={17} /> : <ArrowDown size={17} />}
            </Text>
          ) : (
            <QuestionCircle size={35} />
          )}
        </UnstyledButton>
      </Popover.Target>
      <Popover.Dropdown data-menu-dropdown className={styles.helpNavMenuDropdown}>
        <div onKeyDown={handleKeyDown} role="menu"> {/* Removed tabIndex={0} */}
          <List className={styles.helpNavMenuDropdown__list}>
            {[
              { to: PATHS.SUPPORT, label: 'Support', icon: <QuestionCircle /> },
              // { to: PATHS.SUPPORT, label: 'Help', icon: <ArrowRightCircle /> },
              { to: PATHS.FAQ, label: 'FAQs', icon: <FileText /> }
            ].map((item, index) => (
              <List.Item
                key={item.to}
                role="menuitem"
                tabIndex={focusedIndex === index ? 0 : -1}
                className={styles.helpNavMenuDropdown__item}
                >
                <Link
                onClick={toggleOpened}
                to={item.to} 
                  ref={(el) => (menuItemsRef.current[index] = el)} // Attach ref to each menu item
               >
                  {item.icon}
                  {item.label}
                  <ArrowUpRight />
                </Link>
              </List.Item>
            ))}
          </List>
        </div>
      </Popover.Dropdown>
    </Popover>
  );
};